<div class="tw-flex tw-flex-col tw-gap-4">
  <div class="tw-flex tw-items-end tw-gap-4">
    <app-input
      [label]="'symbolNameCode' | i18n"
      [placeholder]="'enterSymbolNameCode' | i18n"
      [isRequired]="true"
      [value]="symbol().name || symbol().code"
      [isDisabled]="isReadOnlySymbol()"
      (outputValue)="onInputName($event, 'name')"
      class="tw-w-full"
    >
    </app-input>
    <app-gloss-button
      [options]="{
        text: 'save' | i18n,
        class: 'primary',
        type: 'submit',
        isEnabled: !isReadOnlySymbol(),
        onClick: saveName.bind(this),
      }"
    ></app-gloss-button>
  </div>
  <app-dropdown-select
    [label]="'symbolGroup' | i18n"
    [options]="groupOptions"
    [selectedOption]="groupValue"
    [isEnabled]="!isReadOnlySymbol()"
    [detachPanel]="true"
    [sort]="'date'"
    (optionSelected)="onGroupChange($event)"
  ></app-dropdown-select>
  @if (!isReadOnlySymbol()) {
    <div data-testid="price-form-section" class="tw-flex tw-flex-col tw-gap-3">
      <div class="border-bottom-gray tw-pb-1"></div>
      @if (isEodhdInstalled()) {
        <div class="tw-flex tw-flex-col tw-gap-3">
          <!-- Find Price / Manually Enter Price segmented toggle (sliding thumb) -->
          @if (editMenu().options.length > 1) {
            <div
              class="tw-relative tw-flex tw-h-12 tw-w-full tw-items-center tw-rounded-2xl tw-bg-dt-surface-page tw-p-1"
            >
              <div
                class="tw-pointer-events-none tw-absolute tw-left-1 tw-top-1 tw-bottom-1 tw-w-[calc(50%-4px)] tw-rounded-2xl tw-bg-color-surface-elevated border-gradient-neuomorphic tw-shadow-neuomorphic-subtle-minimal tw-transition-transform tw-duration-300 tw-ease-out"
                [style.transform]="'translateX(' + activeTabIndex() * 100 + '%)'"
              ></div>
              @for (option of editMenu().options; track option.value) {
                <button
                  type="button"
                  (click)="currentTab.set(option.value)"
                  class="tw-relative tw-z-10 tw-flex tw-h-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-center tw-border-0 tw-bg-transparent"
                >
                  <span
                    class="tw-text-[14px] tw-font-medium tw-tracking-[0.005em] tw-transition-colors"
                    [ngClass]="
                      currentTab() === option.value
                        ? 'tw-text-dt-text-action'
                        : 'tw-text-dt-text-secondary'
                    "
                  >
                    {{ option.displayValue }}
                  </span>
                </button>
              }
            </div>
          } @else {
            <span class="tw-text-[14px] tw-font-medium tw-text-dt-text-secondary">
              {{ editMenu().options[0]?.displayValue }}
            </span>
          }
          @if (isFreeSubscription()) {
            <app-premium-callout></app-premium-callout>
          }
        </div>
      }
      @if (isFindPrice()) {
        <app-input
          [label]="('findOn' | i18n) + ' ' + selectedPlugin.name"
          [isDisabled]="isFreeSubscription() || isEodhdSynced()"
          [placeholder]="'searchByEnteringSymbolCompanyName' | i18n"
          [isRequired]="true"
          [value]="eodhdSymbolCode()"
          (outputValue)="onSearchInputChange($event, addPriceFormGroup.get('date').value)"
        >
        </app-input>
      }
      <!-- Date picker: neumorphic trigger + app-calendar (single date) overlay -->
      <div class="tw-flex tw-w-full tw-flex-col tw-gap-1">
        <span class="tw-text-[13px] sm:tw-text-[12px] tw-font-bold tw-text-dt-text-tertiary">{{
          "asOnDate" | i18n
        }}</span>
        <app-date-field
          [displayText]="addPriceFormGroup.get('date').value"
          [dateFilter]="dateFilter"
          [isDisabled]="
            !((!isFreeSubscription() && isFindPrice()) || (!isReadOnlySymbol() && !isFindPrice()))
          "
          [overlayWidth]="350"
          (dateChange)="onDatePicked($event)"
        ></app-date-field>
      </div>
      <div class="tw-flex tw-gap-4" [formGroup]="addPriceFormGroup">
        <!--    price-->
        <app-input
          [label]="'price' | i18n"
          [isRequired]="true"
          [type]="'number'"
          [isDisabled]="isFindPrice() || isReadOnlySymbol()"
          formControlName="price"
          class="tw-w-full"
        >
        </app-input>
        <!--    currency-->
        <app-currencies
          class="tw-w-full tw-font-neutral-800 tw-mb-3"
          [disabled]="isFindPrice() || isReadOnlySymbol() || isEodhdSynced()"
          (onSelectCurrency)="onInput($event, 'currency')"
          [label]="'Currency'"
          [defaultCurrency]="currentDisplayCurrency()"
          [detachPanel]="true"
        ></app-currencies>
      </div>
      <div class="tw-flex tw-justify-end">
        <app-gloss-button
          [options]="{
            text: 'addPrice' | i18n,
            class: 'primary',
            type: 'submit',
            isEnabled:
              (!isFreeSubscription() && isFindPrice()) || (!isReadOnlySymbol() && !isFindPrice()),
            onClick: addPrice.bind(this),
          }"
        ></app-gloss-button>
      </div>
    </div>
  }
</div>
